<div id="wrapper">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
  </div>

  <div style="margin-bottom: 0px;">
    <app-tab-nav
      (updateType)="this.type=$event"
      (updatePostpaid)="this.postpago=$event"
      (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event"
      (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event"
      (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()">
    </app-tab-nav>
  </div>
  <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
  <div class="allcont logsize" *ngIf="this.totalAccountList > 0">
    <div class="basicrow ">
      <div class="container">
        <div class="basicr-line-i marTopRes">
          <div class="fulltitle f-btitle autodef">
            <span class="icon-dash-18"></span> Mi Consumo
          </div>
          <div class="pull-right" *ngIf="this.type=='postpaid'||this.type=='fixed'">
            <label class="label-r sidenmbr vcenter w-auto">
              <span class="tabcell">
                N&uacute;mero de Cuenta
              </span>
            </label>
            <div class="autorow subsc  mob-wid pull-right">
              <div *ngIf="this.totalAccountList > 0">
                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f"
                  style="background-image:url(/assets/images/selectabarrw.png)">
                  <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow">
      <div class="container">
        <div class="basicrow m-top-i">
          <div *ngIf="this.type=='postpaid'">
            <div class="difftabs">
              <div (click)="this.statusChange(1);"
                [className]="this.selTab===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Datos
              </div>
              <div (click)="this.statusChange(2);"
                [className]="this.selTab===2 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                Llamadas y Mensajes
              </div>
            </div>
          </div>
          <div *ngIf="this.type=='fixed'">
            <div *ngIf="this.mixed==true">
              <div class="difftabs">
                <div (click)="this.statusChange(1);"
                  [className]="this.selTab===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                  Datos
                </div>
                <div (click)="this.statusChange(2);"
                  [className]="this.selTab===2 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                  Llamadas y Mensajes
                </div>
              </div>
            </div>
            <div *ngIf="this.mixed==false">
              <div class="difftabs">
                <div (click)="this.statusChange(1);"
                  [className]="this.selTab===1 ? 'tab1 difft-def on ' : 'tab1 difft-def'">
                  Llamadas
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="this.type=='postpaid'||this.type=='prepaid'">
          <div id="dataInfo" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 1 ? 'block' : 'none' }">
            <div class="basicrow mbott-i">
              <div class="container-usage">
                <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                  <div *ngIf="inf.productTypeField=='G'">
                    <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                      (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                      <span class="roboto-l">M&Oacute;VIL </span>
                      <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                      <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                      <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                    </div>
                    <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                      <div class="basicrow allpads bordsdef text-justify mob-txt-a"
                        *ngIf="this.type=='postpaid'||this.type=='fixed'">
                        <app-data [index]="i"></app-data>
                      </div>
                      <div class="basicrow allpads bordsdef text-justify mob-txt-a" *ngIf="this.type=='prepaid'">
                        <app-prepaid-usage [index]="i" [useminvoice]="inf.usageInfoField.minutesUsageField"
                          [mms]="inf.usageInfoField.mMSUsageField">
                        </app-prepaid-usage>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="dataAndCall" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 2 ? 'block' : 'none' }">
            <div class="basicrow mbott-i">
              <div class="container-usage">
                <div class="basicrow m-font">
                  <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                    <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                      (click)="updateExpand(i)" [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                      <div *ngIf="inf.productTypeField=='G'">
                        <span class="roboto-l">M&Oacute;VIL </span>
                        <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                        <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                        <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                      </div>
                      <div *ngIf="inf.productTypeField=='O'">
                        <span class="roboto-l">TELEFONÍA FIJA </span>
                        <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                        <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                        <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                      <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                        <app-fixed-usage [index]="i" [prodType]="inf.productTypeField"
                          [useminvoice]="inf.usageInfoField.minutesUsageField"
                          [useminLD]="inf.usageInfoField.lDUsageField" [useminLDI]="inf.usageInfoField.lDIUsageField"
                          [smsmms]="inf.usageInfoField.sMSUSageField"
                          [smsprem]="inf.usageInfoField.sMSPremiunUsageField" [mms]="inf.usageInfoField.mMSUsageField">
                        </app-fixed-usage>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="this.type=='fixed'">
          <div *ngIf="this.mixed==true">
            <div id="dataInfo" class="basicrow m-top-ii" [ngStyle]="{'display':this.selTab === 1 ? 'block' : 'none' }">
              <div class="basicrow mbott-i">
                <div class="container-usage">
                  <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                    <div *ngIf="inf.productTypeField=='G'">
                      <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                        (click)="updateExpand(i)"
                        [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                        <span class="roboto-l">M&Oacute;VIL </span>
                        <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                        <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                        <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                      </div>
                      <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                        <div class="basicrow allpads bordsdef text-justify mob-txt-a"
                          *ngIf="this.type=='postpaid' || this.type=='fixed'">
                          <app-data [index]="i"></app-data>
                        </div>
                        <div class="basicrow allpads bordsdef text-justify mob-txt-a" *ngIf="this.type=='prepaid'">
                          <app-prepaid-usage [index]="i" [useminvoice]="inf.usageInfoField.minutesUsageField"
                            [mms]="inf.usageInfoField.mMSUsageField">
                          </app-prepaid-usage>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="dataAndCall" class="basicrow m-top-ii"
              [ngStyle]="{'display':this.selTab === 2 ? 'block' : 'none' }">
              <div class="basicrow mbott-i">
                <div class="container-usage">
                  <div class="basicrow m-font">
                    <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                      <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                        (click)="updateExpand(i)"
                        [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                        <div *ngIf="inf.productTypeField=='G'">
                          <span class="roboto-l">M&Oacute;VIL </span>
                          <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                          <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                          <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                        </div>
                        <div *ngIf="inf.productTypeField=='O'">
                          <span class="roboto-l">TELEFONÍA FIJA </span>
                          <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                          <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                          <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                        <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                          <app-fixed-usage [index]="i" [prodType]="inf.productTypeField"
                            [useminvoice]="inf.usageInfoField.minutesUsageField"
                            [useminLD]="inf.usageInfoField.lDUsageField" [useminLDI]="inf.usageInfoField.lDIUsageField"
                            [smsmms]="inf.usageInfoField.sMSUSageField"
                            [smsprem]="inf.usageInfoField.sMSPremiunUsageField"
                            [mms]="inf.usageInfoField.mMSUsageField">
                          </app-fixed-usage>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="this.mixed==false">
            <div id="dataAndCall" class="basicrow m-top-ii"
              [ngStyle]="{'display':this.selTab === 1 ? 'block' : 'none' }">
              <div class="basicrow mbott-i">
                <div class="container-usage">
                  <div class="basicrow m-font">
                    <div *ngFor="let inf of this.info; let i = index" class="basicrow m">
                      <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt"
                        (click)="updateExpand(i)"
                        [ngClass]="{'mon': this.expand[i]== true,'': this.expand[i] == false}">
                        <div *ngIf="inf.productTypeField=='G'">
                          <span class="roboto-l">M&Oacute;VIL </span>
                          <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                          <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                          <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                        </div>

                        <div *ngIf="inf.productTypeField=='O'">
                          <span class="roboto-l">TELEFONÍA FIJA </span>
                          <span class="roboto-l">{{this.global.mask(inf.subscriberNumberField)}}</span>
                          <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
                          <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
                        <div class="basicrow allpads bordsdef text-justify mob-txt-a">
                          <app-fixed-usage [index]="i" [prodType]="inf.productTypeField"
                            [useminvoice]="inf.usageInfoField.minutesUsageField"
                            [useminLD]="inf.usageInfoField.lDUsageField" [useminLDI]="inf.usageInfoField.lDIUsageField"
                            [smsmms]="inf.usageInfoField.sMSUSageField"
                            [smsprem]="inf.usageInfoField.sMSPremiunUsageField"
                            [mms]="inf.usageInfoField.mMSUsageField">
                          </app-fixed-usage>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
